import { User } from "../types";

export function getNacoAvatar(user: User): string {
  if (user) {
    return `https://account.kemnaker.go.id/users/${user.id}/picture`;
  }

  return "";
}